import { render, staticRenderFns } from "./EzUserSettings.vue?vue&type=template&id=ef52acee&scoped=true&"
import script from "./EzUserSettings.vue?vue&type=script&lang=js&"
export * from "./EzUserSettings.vue?vue&type=script&lang=js&"
import style0 from "./EzUserSettings.vue?vue&type=style&index=0&id=ef52acee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef52acee",
  null
  
)

export default component.exports